import { render, staticRenderFns } from "./DIsputeResolutionFilesDetails.vue?vue&type=template&id=d2716b9e&scoped=true&"
import script from "./DIsputeResolutionFilesDetails.vue?vue&type=script&lang=js&"
export * from "./DIsputeResolutionFilesDetails.vue?vue&type=script&lang=js&"
import style0 from "./DIsputeResolutionFilesDetails.vue?vue&type=style&index=0&id=d2716b9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2716b9e",
  null
  
)

export default component.exports